<template lang='pug'>
  i.svg-icon.svg-icon-profile
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M16.21,16.21v25.342h25.342V16.21H16.21z M58.447,16.21v25.342h25.342V16.21H58.447z M16.21,58.447V83.79h25.342V58.447H16.21z M58.447,58.447V83.79h25.342V58.447H58.447z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}

</script>